import axios from 'axios';
import { config } from './../Constants'

const instance = axios.create({
    baseURL: config.url.BASE_URL
});

export const get = (apiUrl, params, successFunc, errorFunc, finallFunc) => {
    return instance.get(apiUrl, { params : params })
    .then(successFunc)
    .catch(errorFunc)
    .then(finallFunc);
}

export const post = (apiUrl, params, successFunc, errorFunc, finallFunc) => {
    return instance.post(apiUrl, { params : params })
    .then(successFunc)
    .catch(errorFunc)
    .then(finallFunc);
}